import Globals from "../../Globals.js";
import Pqp from "../Pqp.js";
import ServiceManagerFakes from "./ServiceManagerFakes.js";
import ServiceManagerRoutes from "./ServiceManagerRoutes.js";

export default class ServiceManager {

	static hello() {
		console.log("Sono ServiceManager!!!")
	}

	static standardCall(apiRoute, rq, callback) {
		ServiceManager._executeStandardCall(apiRoute, rq, callback);
	}

	// solo per le chimate standard versop il nostro server
	static _executeStandardCall(apiRoute, rq, callback, method = "POST", contentType = "application/json; charset=utf-8") {
		// pipeline step1
		ServiceManager._customPipeLine(apiRoute, 1, { rq: rq });
		//
		let headers = {};
		// api key
		headers.api_key = TheApp.CurrentContext.app.jsApiKey;
		// access_token
		headers.access_token = TheApp.CurrentContext.userSession ? TheApp.CurrentContext.userSession.Bearer : null;
		// lingua
		headers.lng = TheApp.Env.Locale;
		// la url
		let wsUrl = TheApp.Env.BaseUrl + (apiRoute.startsWith("/") ? apiRoute.substr(1) : apiRoute);
		//
		console.log("_executeStandardCall ");
		console.log("\t method " + method);
		console.log("\t wsUrl " + wsUrl);
		console.log("\t api_key " + headers.api_key);
		console.log("\t access_token " + headers.access_token);
		console.log("\t lng " + headers.lng);
		console.log("\t rq " + JSON.stringify(rq));
		//
		let toSend = {
			type: method ? method : "POST",
			url: wsUrl,
			data: JSON.stringify(rq ? rq : {}),
			dataType: "json",
			headers: headers,
			contentType: contentType ? contentType : "application/json; charset=utf-8",
			complete: jQuery.proxy(ServiceManager._handlerStandardCall, ServiceManager, callback, apiRoute, rq)
		}
		$.ajax(toSend);
	}
	//
	static _handlerStandardCall(callback, apiRoute, rq, ajaxResponse) {
		let rs = { StatusCode: 503, Message: "ServiceUnavailable", Success: false };
		if (ajaxResponse) {
			let tmp = ajaxResponse.responseJSON;
			if (tmp && tmp.StatusCode != undefined) {
				rs = tmp;
			}
			else {
				if (ajaxResponse.status && ajaxResponse.status != 200 && ajaxResponse.status != 201 && ajaxResponse.status != 202) {
					rs.StatusCode = ajaxResponse.status;
					if (tmp) {
						if (tmp.Message) {
							rs.Message = tmp.Message;
						}
                    }
						
				}
			}
		}
		// pipeline step2
		ServiceManager._customPipeLine(apiRoute, 2, { rq: rq, rs: rs });
		//
		console.log("\t rs:" + JSON.stringify(rs));
		// gestioni custom: todo
		if (callback)
			callback(rs);

	}
	//
	static _customPipeLine(apiRoute, step, data) {
		// login
		if (apiRoute.indexOf("/auth/login") != -1 || apiRoute.indexOf("/auth/tokenlogin") != -1 || apiRoute.indexOf("/auth/adduser" != -1)) {
			if (step == 1) {
				// PRE
				if (data.rq.SetAsPrincipal == undefined || data.rq.SetAsPrincipal == null)
					data.rq.SetAsPrincipal = true;
			} else if (step == 2) {
				// POST
				if (data.rs.Success && data.rs.Session) {
					TheApp.CurrentContext.userSession = data.rs.Session;
					TheApp.CurrentContext.Bearer = data.rs.Session.Bearer;
					TheApp.CurrentContext.IsAuthenticated = true;
					TheDisp.dispatchEvent(TheDisp.EV_USERSESSION_UPDATE);
				}
			}
		}
		// user
		if (apiRoute.indexOf("/auth/user") != -1) {
			if (step == 1) {
				// PRE
			} else if (step == 2) {
				// POST
				if (data.rs.Success && data.rs.Session) {
					TheApp.CurrentContext.userSession = data.rs.Session;
					TheApp.CurrentContext.Bearer = data.rs.Session.Bearer;
					TheApp.CurrentContext.IsAuthenticated = true;
					TheDisp.dispatchEvent(TheDisp.EV_USERSESSION_UPDATE);
				}
			}
		}
		// logout
		else if (apiRoute.indexOf("/auth/logout") != -1) {
			if (step == 1) {
				// PRE
				if (data.rq.ForceClearPrincipal == undefined || data.rq.ForceClearPrincipal == null)
					data.rq.ForceClearPrincipal = true;
			} else if (step == 2) {
				// POST
				if (data.rs.Success) {
					TheApp.CurrentContext.userSession = null;
					TheApp.CurrentContext.Bearer = null;
					TheApp.CurrentContext.IsAuthenticated = false;
					TheDisp.dispatchEvent(TheDisp.EV_USERSESSION_UPDATE);
				}
			}
		}
	}

}

// ServiceManager.lastColor = -1;
window.thatServiceManeger = ServiceManager;